import { useState } from 'react';
import { ethers } from 'ethers';
import indexFundAbi from '../abi.json';

const IndexFundAddress = '0x123...'; // Replace with the address of your deployed contract
const provider = new ethers.providers.Web3Provider(window.ethereum);
const signer = provider.getSigner();

const IndexFund = new ethers.Contract(IndexFundAddress, indexFundAbi.abi, signer);

function SwapTokens() {
  const [amountIn, setAmountIn] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  async function handleSwapTokens(event) {
    event.preventDefault();

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const amount = ethers.utils.parseEther(amountIn); // Convert input to wei
      const tx = await IndexFund.swapTokens(amount);
      await tx.wait();
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  }

  return (
    <form onSubmit={handleSwapTokens}>
      <label>
        Amount In:
        <input type="number" value={amountIn} onChange={(e) => setAmountIn(e.target.value)} />
      </label>
      <button type="submit" disabled={loading}>
        {loading ? 'Loading...' : 'Swap Tokens'}
      </button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>Tokens swapped successfully!</p>}
    </form>
  );
}

export default SwapTokens;